<template>
  <div id="layout">
    <main>
      <menu-bar></menu-bar>
      <app-content />
      <footer-bar></footer-bar>
    </main>
  </div>
</template>

<script>
// Layout components
import MenuBar from "@/views/site/blocks/MenuBar";
import FooterBar from "@/views/site/blocks/FooterBar";
import AppContent from "@/views/site/blocks/AppContent";

const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Govava",
  url: "https://govava.com",
  description:
    "AI-powered gifting ecosystem for B2C gift discovery and B2B corporate gifting, using personality profiling and lifestyle mapping to generate personalized recommendations across 3,000+ retail stores.",
  knowsAbout: [
    "Gift recommendation",
    "AI personalization",
    "Corporate gifting",
    "Pet gift recommendations",
    "Retail affiliate integration",
  ],
};

export default {
  name: "SiteLayout",
  metaInfo: {
    script: [
      {
        vmid: "organization-schema",
        type: "application/ld+json",
        json: ORGANIZATION_SCHEMA,
      },
    ],
  },
  data() {
    return {
      route_name: "",
    };
  },
  components: {
    MenuBar,
    FooterBar,
    AppContent,
  },
  created() {
    this.checkurl();
  },
  methods: {
    checkurl() {
      var segment_str = window.location.pathname;
      var segment_array = segment_str.split("/");
      this.route_name = segment_array[1];
    },
  },
  watch: {
    $route(to, from) {
      let split_route = to.path.split("/");
      this.route_name = split_route[1];
    },
  },
};
// Layout components
</script>
